// Exact authenticated profile identities; numeric IDs are never portable between databases.
// Source identities are added only after verification. Missing mappings deny access.
const identities = Object.freeze([
  ['odoo17-compat', 'https://vendor17development.shakawear.com/pwa', 'shakawear_development_06_04_2026', 134],
  ['odoo17-compat', 'https://vendor17.shakawear.com/pwa', 'shakawear_production', 134],
  ['odoo17-compat', 'https://vendor17.shakawear.com/pwa', 'shakawear_production', 546],
  ['odoo19-compat', 'https://odoo19.shakawear.com/pwa', 'o19live', 134],
  ['odoo19-compat', 'https://odoo19.shakawear.com/pwa', 'o19live', 546],
]);

export function isPilotIdentity(profile, userId) {
  return !!profile && identities.some(([id, url, database, uid]) =>
    profile.id === id && profile.apiBaseUrl === url && profile.database === database && userId === uid);
}
